import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import {
	CleanIcon,
	AddWhiteIcon
} from 'assets/icons';
import { Input, Pagination, Table, DatePicker, Modal } from 'components';
import { InventoryService } from 'services';
import moment from 'moment';
import ModalAdd from './modal-add';
import { checkPermission, Constants, Print } from 'utils';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: '',
	date: '',
	presentation: ''
}

declare var window: any;

class Inventory extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Fecha',
			'Producto',
			'Presentación',
			'Motivo',
			'Cantidad Inicial',
			'Existencia'
		],
		visible: false
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Inventario',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await InventoryService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
			date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD')
		});
		this.setState({
			data: res.movements.rows,
			last_page: res.movements.count
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	onClose = () => {
		this.setState({
			visible: false
		},() => this.load(true));
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	downloadExcel = async () => {
		const res: any = await InventoryService.admin.download({
			...this.state.form,
			date: this.state.form.date && moment(this.state.form.date).format('YYYY-MM-DD')
		});
		if (window.webkit && window.webkit.messageHandlers) {
			const message = 'open_url';
			const sendToNative = {
				message,
				url: Constants.BASE_STORAGE + res.url
			}
			const stringifiedMessageObj = JSON.stringify(sendToNative);
	        window.webkit.messageHandlers.cordova_iab.postMessage(stringifiedMessageObj);
	    }
	    else {
	    	Print(Constants.BASE_STORAGE + res.url);
	    }
	}
	
	render() {
		const { visible } = this.state;

		return (
			<div id="admin-shop-inventory">
				<Modal
		          className="modal-add-inventory"
		          visible={ visible }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onClose() }
		        >	
		        	{/*
		        	// @ts-ignore */}
					<ModalAdd
						onClose={ () => this.onClose() }
					/>
		      	</Modal>

				<BackComponent />

				<div className="row row-filter">
					<div className="col-md-9">
						<div className="row">
							<div className="col-md-3">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Producto"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-3">
								<Input
									searchLeft
									value={ this.state.form.presentation }
									name="presentation"
									placeholder="Presentación"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-3">
								<DatePicker
									placeholder="Fecha"
									maxDate={ moment().toDate() }
									onChange={ (text: string) => {
										this.change({
											target: {
												value: text,
												name: 'date'
											}
										},() => this.load(true));
									} }
									value={ this.state.form.date }
								/>
							</div>
							<div className="col-md-3">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-3 text-right">
						{
							checkPermission(Constants.MODULES.INVENTORY,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				{
					this.state.data.length > 0 && (
						<button className="btn btn-excel" onClick={ () => this.downloadExcel() }>
							Exportar a Excel
						</button>
					)
				}

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ moment(i?.created_at).format('DD/MM/YYYY') }</td>
								<td>{ i?.product?.name }</td>
								<td>{ i?.product?.type_id == Constants.PRODUCT_TYPES.PRODUCT ? i?.product?.presentation?.name : '-' }</td>
								<td>{ i?.movement_type?.name }</td>
								<td>{ i?.current_amount }</td>
								<td>{ i?.final_amount }</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Inventory);